var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.maxEarnablePoints > 0)?_c('div',[_c('p',[_vm._v(" "+_vm._s(_vm.$t('rewards.landing.rewards_earned_none', [ _vm.formatCurrency(_vm.totalPointsEarned), _vm.formatCurrency(_vm.maxEarnablePoints), ]))+" ")]),_c('ProgressBar',{staticClass:"mt-10",attrs:{"gradient":"","percentage":_vm.earnedPercentage}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }